<template>
	<div class="base_about">
		<h3 class="title">{{ title }}</h3>
		<div class="content_box" ref="about_content_box">
			<p ref="about_content" class="content">{{ text }}</p>
			<div class="content_more" @click="clickShowAllAbout" v-if="showMore">
				展开<img class="content_more_arrow" src="@/assets/icon/icon_arrow_primary.png" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BaseAbout',
		data: () => ({
			showMore: false
		}),
		props: {
			title: {
				type: String,
				default: '简介'
			},
			text: {
				type: String,
				default: ''
			},
			showAll: {
				type: Boolean,
				default: false
			}
		},
		mounted () {
			this.$nextTick(() => {
				if (this.showAll) {
					this.$refs.about_content_box.style.maxHeight = 'initial'
					this.showMore = false
				} else {
					const { about_content, about_content_box } = this.$refs
					if (about_content && about_content_box) {
						this.showMore = about_content.offsetHeight > about_content_box.offsetHeight
					}
				}
			})
		},
		methods: {
			clickShowAllAbout () {
				this.$refs.about_content_box.style.maxHeight = this.$refs.about_content.offsetHeight + 'px'
				this.showMore = false
			},
		}
	};
</script>

<style scoped lang="less">
	.about_content {
		font-family: PingFangSC-Regular;
		font-size: 28px;
		font-weight: normal;
		line-height: 42px;
		color: #646A73;
		word-break: break-all;
		text-align: justify;
	}

	.base_about {
		margin-top: 40px;
		>.title {
			height: 42px;
			font-family: PingFangSC-Medium;
			font-size: 30px;
			font-weight: 500;
			color: #000;
			margin-bottom: 14px;
		}
		.content{
			.about_content();
		}
		.content_box {
			max-height: 168px;
			overflow: hidden;
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			line-height: 42px;
			color: #646A73;
			word-break: break-all;
			text-align: justify;
			position: relative;
			transition: all .5s;
			.about_content();
			.content_more {
				position: absolute;
				bottom: 0;
				right: 0;
				background-color: @gray-1;
				display: flex;
				align-items: center;
				color: @primary;
				padding-left: 2px;
				.content_more_arrow{
					width: 28px;
					vertical-align: middle;
				}
			}
		}
	}
</style>
